import styles from './DocumentCount.module.css'

export interface DocumentCountProps {
  totalDocuments: number
  /**
   * The archived filter's selected values.
   */
  archivedFilterValue?: (boolean | undefined)[]
}

export function DocumentCount({
  totalDocuments,
  archivedFilterValue,
}: DocumentCountProps) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {toArchivedStatus(archivedFilterValue?.slice())}
        <span className={styles.count}>&nbsp;({totalDocuments ?? 0})</span>
      </div>
    </div>
  )
}

function toArchivedStatus(archivedFilterValue?: (boolean | undefined)[]) {
  switch (archivedFilterValue?.pop()) {
    case true:
      return 'Archived documents'
    case false:
      return 'Unarchived documents'
    default:
      return 'All documents'
  }
}
